import React from "react";
import SectionTitle from './section-title'
import "./book-page.m.css";

export default function AuthorEventBlocks() {
  return (
    <section styleName="author-events">
      {/* Author Spotlight */}
      <div styleName="author-card">
        <SectionTitle
          title="Author Spotlight"
          width="30%"
          titleColor="var(--text-neutral)"
        />

        <img
          src="https://images.assettype.com/newslaundry/2026-10-14/2evvjyzf/Author-2.png"
          alt="Author Spotlight"
          styleName="author-events-image"
        />
      </div>

      {/* Events */}
      <div styleName="events-card">
        <SectionTitle
          title="Events"
          width="14%"
          titleColor="var(--text-neutral)"
        />

        <img
          src="https://images.assettype.com/newslaundry/2026-10-14/6kvtyw0h/events-4.png"
          alt="Events"
          styleName="author-events-image"
        />
      </div>
    </section>
  );
}